module.exports = __webpack_public_path__ + "static/media/porto-seguro-logo-2.4daa4d90.png";